/** These figures describe a population/process or map proxy, not this load's service date. */
export const CONTEXT_ONLY_QUEUE_TEXT = /\b(?:regional|nationwide|national|historical|benchmark|heuristic|proximity|HIFLD|LBNL|Queued Up|generation[- ]queue|generator[- ]queue|generation interconnection|generator interconnection)\b|\b(?:ISO|RTO|MISO|PJM|ERCOT|CAISO|SPP|NYISO|ISO-NE)\s+(?:(?:median|average|P50)\s+)?queue\b/i;

/**
 * A prose fallback remains an unverified claim, but must at least identify a
 * site load and its utility study/letter. A bare "MISO queue 2.3 years" cannot
 * undo the canonical fact store's source-scope guard. Inspect clauses so an
 * unrelated benchmark elsewhere does not erase an actual utility statement.
 */
export function siteLoadQueueYearsFromText(text: string): number | null {
  const clauses = text.split(/(?:[.!?](?!\d)\s+|[;\n])/);
  for (const clause of clauses) {
    if (CONTEXT_ONLY_QUEUE_TEXT.test(clause)) continue;
    if (!/\b(?:this|the|our)\s+(?:site|project|campus|facility|data[- ]center|load)\b|\bsite[- ]specific\b/i.test(clause)) continue;
    if (!/\b(?:utility|service[- ]letter|load[- ]service study|load[- ]interconnection study)\b/i.test(clause)) continue;
    if (/\b(?:no|without|missing|awaiting|pending|unavailable|unknown|unconfirmed)\b|\bnot\s+(?:yet\s+)?(?:confirmed|available|provided|established)\b/i.test(clause)) continue;
    const match = clause.match(/\b(?:queue|interconnection|load[- ]service|service timeline)\b[^\d]{0,80}(\d+(?:\.\d+)?)\s*(?:years?|yrs?)\b/i);
    if (!match) continue;
    const years = Number(match[1]);
    if (Number.isFinite(years) && years > 0) return years;
  }
  return null;
}
